import { render, staticRenderFns } from "./BeScrollTop.vue?vue&type=template&id=2036bc12&"
import script from "./BeScrollTop.vue?vue&type=script&lang=js&"
export * from "./BeScrollTop.vue?vue&type=script&lang=js&"
import style0 from "./BeScrollTop.vue?vue&type=style&index=0&id=2036bc12&prod&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports